/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-12-11 10:13:42
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Banner } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { getShop } from 'src/helpers';

type Props = {
  permissionURL: string,
  onDismiss: Function
};

type ComposedProps = Props & WithI18nProps;

class GrantPermissionNotif extends Component<ComposedProps> {
  render() {
    const { i18n } = this.props;

    return (
      <Banner
        title={i18n.translate('AdminHTML.Translation.GrantPermissionNotif.title')}
        status="warning"
        action={{
          onAction: this.handleUpdatePermission,
          content: i18n.translate('AdminHTML.Translation.GrantPermissionNotif.action')
        }}>
        <p>{i18n.translate('AdminHTML.Translation.GrantPermissionNotif.content')}</p>
      </Banner>
    );
  }

  handleUpdatePermission = () => {
    const { permissionURL } = this.props;

    // Setup redirect URI
    try {
      localStorage.setItem(`${getShop()}-permissionApproval-redirectURI`, '/translation');
    } catch (error) {}

    window.top.location.href = permissionURL;
  };
}

export default withI18n()(GrantPermissionNotif);
